import ReactPaginate from 'react-paginate';

export default ({ ...props }) => (
	<div>
		<div className="container">
			<div className="mb-4 d-flex">
				<div className="border-bottom border-softgray w-33 flex-fill mb-3 line">
					<h2 className="invisible">Galeri</h2>
				</div>
				<div className="flex-fill position-relative">
					<div className="d-flex justify-content-between position-absolute w-100 head-right">
						<div className="paging simple">
							<ReactPaginate
								pageCount={props.last_page}
								initialPage={parseInt(props.currPage) - 1}
								hrefBuilder={(page) => '/galeri/page/' + page}
								onPageChange={(data) => {
									window.location.href = `/galeri/page/${data.selected + 1}`;
								}}
								disableInitialCallback={true}
								containerClassName="pagination"
								breakClassName="page-item"
								breakLabel={<i>...</i>}
								pageClassName="page-item"
								previousClassName="page-item mr-3"
								nextClassName="page-item"
								pageLinkClassName="page-link d-flex justify-content-center align-items-center"
								previousLinkClassName="btn page-link"
								nextLinkClassName="btn page-link"
								previousLabel={<i className="arrow left" />}
								nextLabel={<i className="arrow right" />}
							/>
						</div>
						<div className="text-left">
							<h5 className="text-primary">{parseInt(props.currPage) > 9 ? props.currPage : '0'+props.currPage}</h5>
							<h5 className="text-softgray mb-0 ml-3 pl-3 position-relative diag-line">{parseInt(props.last_page) > 9 ? props.last_page : '0'+props.last_page}</h5>
						</div>
					</div>
				</div>
			</div>
			<div className="py-2" />
		</div>
		<style jsx>{`
			@import './styles/jmto-custom';
			.diag-line::after {
				content: "";
				position: absolute;
				border-top: 1px solid $softgray;
				width: 40px;
				transform: rotate(-45deg);
				left: -0.6em;
            }
            .invisible{
                margin-top:-20px;
            }
            .text-left{
                text-align:left;
            }
            .w-33{
                width:33%;
			}
			
			@media (max-width: 767.98px) {
				.line{
					display:none !important;
				}
			}
		`}</style>
	</div>
);
